import { Label, Select } from 'flowbite-react'
import {
  EXPORT_FORMAT_EMAILS_ONLY,
  EXPORT_FORMAT_EMAILS_WITH_PAYMENTS,
  type ExportFormat,
} from '@constants/exports'

interface ExportFormatSelectProps {
  value: ExportFormat
  onChange: (next: ExportFormat) => void
}

function ExportFormatSelect({ value, onChange }: ExportFormatSelectProps) {
  return (
    <div>
      <Label
        className="mb-2 block text-sm font-semibold text-slate-950 dark:text-slate-100"
        htmlFor="export-format"
      >
        Формат выгрузки
      </Label>
      <Select
        id="export-format"
        value={String(value)}
        onChange={(event) => onChange(Number(event.target.value) as ExportFormat)}
      >
        <option value={EXPORT_FORMAT_EMAILS_ONLY}>Только email</option>
        <option value={EXPORT_FORMAT_EMAILS_WITH_PAYMENTS}>
          Email с суммой платежей за все время
        </option>
      </Select>
    </div>
  )
}

export default ExportFormatSelect
